import "bootstrap/dist/css/bootstrap.css"
import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { initializeLocales } from "./locale/lang"
import "./scss/site.scss"
import configureStoreWrapper from "./store/configureStore"
import { getQueryValueFromCurrentUrl } from "./util/urlUtil"

export function initialize(Router: (props: any) => JSX.Element | null) {
    // Create browser history to use in the Redux store
    //const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")

    // Get the application-wide store instance, prepopulating with state from the server where available.
    const lang = getQueryValueFromCurrentUrl("language")
    initializeLocales(lang)

    const initialState = window.initialReduxState
    const store = configureStoreWrapper(initialState)

    const rootElement = document.getElementById("root")
    if (rootElement) {
        createRoot(rootElement).render(
            <Provider store={store}>
                <Router />
            </Provider>
        )
    }
}
